// extracted by mini-css-extract-plugin
module.exports = {"tag":"_9e1425b4d3--tag--C9IdR","tag_close":"_9e1425b4d3--tag_close--u3Y9f"};